<div class="changelog__container"
  [ngClass]="{'changelog__container--dialog': !isChangelogPage}">
  @if (isChangelogPage && !mobile && firstLoadingDone) {
    <hpo-card-content
      class="changelog__filters">
      <div class="changelog__filters-title">{{ 'default.filterProducts' | blah }}</div>
      <app-product-list [GroupPriority]="localGroupPriority.HEADPOWER"
        [products]="products"
        [stacked]="true"
        [selectedProductId]="selectedProductId"
        (emitProductSelect)="selectItem($event)">
      </app-product-list>
      <div class="supplier-products__container">
        <div class="changelog__filters-title">{{ 'default.companysInstructions' | blah }}:</div>
        <app-product-list [GroupPriority]="localGroupPriority.SUPPLIER"
          [products]="products"
          [stacked]="true"
          [catalogView]="true"
          [selectedProductId]="selectedProductId"
          (emitProductSelect)="selectItem($event)">
        </app-product-list>
      </div>
    </hpo-card-content>
  }
  <hpo-card-content class="changelog__content">
    @if (isChangelogPage) {
      <div
        class="changelog-page--header">
        <div class="header-text">{{ 'default.changelogTitle' | blah }}</div>
        @if (isChangelogPage) {
          <ng-container *ngTemplateOutlet="paginator"
          ></ng-container>
        }
      </div>
    }
    @if (loading) {
      <div
        class="catalog__placeholders">
        <hpo-placeholder type="row"></hpo-placeholder>
        <hpo-placeholder type="row"></hpo-placeholder>
        <hpo-placeholder type="row"></hpo-placeholder>
      </div>
    }
    @if (!loading) {
      @if (mobile) {
        <mat-chip-listbox
          style="display: block; margin-bottom: 20px;">
          @if (selectedProductId) {
            <mat-chip-option
              (removed)="selectItem(undefined)">
              {{productName}}
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-option>
          }
        </mat-chip-listbox>
      }
      @if (selectedProductId === 0 && isChangelogPage) {
        <div>
          {{ 'default.selectInstructionProduct' | blah }}
        </div>
      }
      @if (changelogEntries[selectedProductId].length === 0 && selectedProductId !== 0) {
        <div>
          {{ 'default.changelogEmpty' | blah }}
        </div>
      }
      @for (changelogEntry of changelogView; track changelogEntry) {
        <div
          class="entry">
          <div class="title">
            {{ changelogEntry.attributes.created | date }} - {{ changelogEntry.attributes.name }}
          </div>
          <div class="description"
          [innerHTML]="changelogEntry.attributes.description.value || '-'"></div>
        </div>
      }
      <div><ng-container *ngTemplateOutlet="paginator"></ng-container></div>
    }
  </hpo-card-content>
</div>

@if (isChangelogPage && mobile) {
  <hpo-bottom-nav>
    <hpo-nav-item icon="list"
      (click)="mobileProducts('SUPPLIER')">
      {{ 'default.companysInstructions' | blah }}
    </hpo-nav-item>
    <hpo-nav-item icon="list"
      (click)="mobileProducts('HEADPOWER')">
      {{ 'default.filterProducts' | blah }}
    </hpo-nav-item>
  </hpo-bottom-nav>
}

<ng-template #paginator>
  @if (changelogView.length) {
    <div
      class="paginator">
      <div>
        {{ pageStart }} - {{ pageEnd }} / {{ length }} {{ nextLinks[this.selectedProductId] ? '+' : '' }}
      </div>
      <div class="paginator--buttons">
        <button mat-icon-button
          (click)="handlePageEvent('previous')"
          [disabled]="!pageIndex || loading">
          <mat-icon>navigate_before</mat-icon>
        </button>
        <button mat-icon-button
          (click)="pageEnd === length ? getMoreChangelogEntries() : handlePageEvent('next')"
          [disabled]="(pageEnd === length && !nextLinks[this.selectedProductId]) || loading">
          <mat-icon>navigate_next</mat-icon>
        </button>
      </div>
    </div>
  }
</ng-template>